import { useEffect } from 'react';
import type { OnCommitStageSettings } from '../types';
type SetInitialScaleOnLoadParamsT = {
  containerRef: React.RefObject<HTMLDivElement>;
  stageRef: React.RefObject<HTMLDivElement>;
  isReady: boolean;
  onCommitStageSettings: OnCommitStageSettings;
};
export function useSetInitialScaleOnLoad({
  containerRef,
  stageRef,
  isReady,
  onCommitStageSettings
}: SetInitialScaleOnLoadParamsT) {
  useEffect(() => {
    const container = containerRef.current;
    const stage = stageRef.current;
    if (!container || !stage || !isReady) return;
    const {
      width: stageW,
      height: stageH,
      top: stageTop,
      left: stageLeft
    } = stage.getBoundingClientRect();
    const {
      top: containerTop,
      left: containerLeft
    } = container.getBoundingClientRect();
    const scale = Math.min(container.offsetWidth / stageW, container.offsetHeight / stageH);
    const x = container.offsetWidth / 2 - stageW / 2 - (stageLeft - containerLeft);
    const y = container.offsetHeight / 2 - stageH / 2 - (stageTop - containerTop);
    onCommitStageSettings({
      scale,
      x,
      y
    });
  }, [containerRef, stageRef, isReady, onCommitStageSettings]);
}